"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isDebug_1 = __importDefault(require("../../isDebug"));
const isTest_1 = __importDefault(require("../../isTest"));
exports.default = (level, message, ...objs) => {
    if (!isDebug_1.default || isTest_1.default) {
        return;
    }
    console[level](`[${level}] ${message}`, ...objs); // eslint-disable-line no-console
};
